import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import { getCookieHelper } from "@/shared-helpers/get-cookie.helper";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";

declare const Android: AndroidInterface;

export class AuthenticationHelper {
  static payjoyJwt = "dashboardUser";
  static dashboardJwtSessionKey = "PJ_DashboardJwt";
  static invitationJwt = "creditLineUser";
  static deviceTag = "deviceTag";
  static invitationToken = "token";

  static getAuthHeader(
    method?: string,
    endpoint?: string,
    body?: string
  ): string {
    if (endpoint?.includes("optout")) {
      const token = this.getInvitationToken();
      if (typeof token === "string") {
        const decodedToken = decodeURIComponent(token);
        return `Bearer ${decodedToken}`;
      }
    }

    if (!isAndroid()) {
      const cookiePj = getCookieHelper(this.payjoyJwt);
      if (typeof cookiePj === "string") {
        const decodedCookie = decodeURIComponent(cookiePj);
        return `Bearer ${decodedCookie}`;
      }

      const sessionJwt = sessionStorage.getItem(this.dashboardJwtSessionKey);
      if (sessionJwt) {
        return `Bearer ${sessionJwt}`;
      }
    }

    if (
      Android &&
      typeof Android?.generateSignatureHeader === "function" &&
      method &&
      endpoint
    ) {
      return Android.generateSignatureHeader(
        method,
        endpoint,
        body ?? undefined
      );
    }

    return "";
  }

  static getDeviceTag(): string {
    if (!isAndroid()) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(this.deviceTag) || "";
    }

    if (Android && typeof Android?.getDeviceTag === "function") {
      return Android.getDeviceTag();
    }

    return "";
  }

  static getInvitationToken(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(this.invitationToken) || null;
  }
}
